import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { environment } from '@/environments/environment';
import { LANGUAGE, LanguageHeader } from '@/constants/system';

// Unauthenticated base query. `Cloud-Levvel-Tenant` is gone (batch 004, ADR-6): the
// new architecture resolves the tenant from the request HOST, so the header had no
// reader left — and emitting it required the whole custom-info round trip that
// produced it. Nothing here reads the store any more.
const baseQuery = fetchBaseQuery({
  baseUrl: environment.apiHost,
  prepareHeaders: headers => {
    const selectedLang = localStorage.getItem(LANGUAGE);
    const headerLang = selectedLang
      ? LanguageHeader[selectedLang as keyof typeof LanguageHeader]
      : LanguageHeader.en;

    headers.set('Cloud-Levvel-Source', 'web');
    headers.set('accept-language', headerLang);
    return headers;
  },
});

export default baseQuery;
